var React = require('react');

function CartItemRes (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M9.47465 6.26388L4.8975 7.49033C2.23017 8.20504 0.647257 10.9467 1.36197 13.6141L5.88033 30.4768C6.59504 33.1442 9.33673 34.7271 12.0041 34.0124L33.6272 28.2185","stroke":"#989998","key":0}),React.createElement("rect",{"x":"9.72021","y":"1.46606","width":"35.1017","height":"26.4576","rx":"4.5","stroke":"#989998","key":1}),React.createElement("path",{"d":"M16.3389 22.322L23.2033 15.4575C24.1862 14.4747 25.7797 14.4747 26.7626 15.4575V15.4575M33.627 22.322L26.7626 15.4575M26.7626 15.4575L31.5057 10.7145C32.6773 9.54289 34.5768 9.54289 35.7483 10.7145L40.4914 15.4575","stroke":"#989998","key":2}),React.createElement("circle",{"cx":"16.3388","cy":"7.06776","r":"2.04237","stroke":"#989998","key":3})]);
}

CartItemRes.defaultProps = {"width":"46","height":"36","viewBox":"0 0 46 36","fill":"none"};

module.exports = CartItemRes;

CartItemRes.default = CartItemRes;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/cart-item-res.svg
// module id = 670
// module chunks = 0